<template>
    <div class="loadingScreen">
        <img 
            class="logoImg" 
            v-if="shopData.coverImg"
            :src="require('../assets/vegotarLong.png')" 
        >
        <div class="fulfilling-bouncing-circle-spinner">
            <div class="circle"></div>
            <div class="orbit"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loadingScreen',
    props: {
        shopData: null
    },
    data() {
        return {

        }
    },  
    methods: {
        
    },
}
</script>
<style scoped>
.loadingScreen {
    background: white;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.logoImg {
    position: absolute;
    top: -15px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 210px;
}
.fulfilling-bouncing-circle-spinner, .fulfilling-bouncing-circle-spinner * {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
}

.fulfilling-bouncing-circle-spinner {
    height: 260px;
    width: 260px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    -webkit-animation: fulfilling-bouncing-circle-spinner-animation infinite 4000ms ease;
            animation: fulfilling-bouncing-circle-spinner-animation infinite 4000ms ease;
}

.fulfilling-bouncing-circle-spinner .orbit {
    height: 260px;
    width: 260px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    border: calc(60px * 0.03) solid steelblue;
    -webkit-animation: fulfilling-bouncing-circle-spinner-orbit-animation infinite 4000ms ease;
            animation: fulfilling-bouncing-circle-spinner-orbit-animation infinite 4000ms ease;
}

.fulfilling-bouncing-circle-spinner .circle {
    height: 260px;
    width: 260px;
    color: steelblue;
    display: block;
    border-radius: 50%;
    position: relative;
    border: calc(60px * 0.1) solid steelblue;
    -webkit-animation: fulfilling-bouncing-circle-spinner-circle-animation infinite 4000ms ease;
            animation: fulfilling-bouncing-circle-spinner-circle-animation infinite 4000ms ease;
    -webkit-transform: rotate(0deg) scale(1);
        -ms-transform: rotate(0deg) scale(1);
            transform: rotate(0deg) scale(1);
}

@-webkit-keyframes fulfilling-bouncing-circle-spinner-animation {
    0% {
        -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
    }
}

@keyframes fulfilling-bouncing-circle-spinner-animation {
    0% {
        -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
    }
}

@-webkit-keyframes fulfilling-bouncing-circle-spinner-orbit-animation {
    0% {
        -webkit-transform: scale(1);
                transform: scale(1);
    }
    50% {
        -webkit-transform: scale(1);
                transform: scale(1);
    }
    62.5% {
        -webkit-transform: scale(0.8);
                transform: scale(0.8);
    }
    75% {
        -webkit-transform: scale(1);
                transform: scale(1);
    }
    87.5% {
        -webkit-transform: scale(0.8);
                transform: scale(0.8);
    }
    100% {
        -webkit-transform: scale(1);
                transform: scale(1);
    }
}

@keyframes fulfilling-bouncing-circle-spinner-orbit-animation {
    0% {
        -webkit-transform: scale(1);
                transform: scale(1);
    }
    50% {
        -webkit-transform: scale(1);
                transform: scale(1);
    }
    62.5% {
        -webkit-transform: scale(0.8);
                transform: scale(0.8);
    }
    75% {
        -webkit-transform: scale(1);
                transform: scale(1);
    }
    87.5% {
        -webkit-transform: scale(0.8);
                transform: scale(0.8);
    }
    100% {
        -webkit-transform: scale(1);
                transform: scale(1);
    }
}

@-webkit-keyframes fulfilling-bouncing-circle-spinner-circle-animation {
    0% {
        -webkit-transform: scale(1);
                transform: scale(1);
        border-color: transparent;
        border-top-color: inherit;
    }
    16.7% {
        border-color: transparent;
        border-top-color: initial;
        border-right-color: initial;
    }
    33.4% {
        border-color: transparent;
        border-top-color: inherit;
        border-right-color: inherit;
        border-bottom-color: inherit;
    }
    50% {
        border-color: inherit;
        -webkit-transform: scale(1);
                transform: scale(1);
    }
    62.5% {
        border-color: inherit;
        -webkit-transform: scale(1.4);
                transform: scale(1.4);
    }
    75% {
        border-color: inherit;
        -webkit-transform: scale(1);
                transform: scale(1);
        opacity: 1;
    }
    87.5% {
        border-color: inherit;
        -webkit-transform: scale(1.4);
                transform: scale(1.4);
    }
    100% {
        border-color: transparent;
        border-top-color: inherit;
        -webkit-transform: scale(1);
                transform: scale(1);
    }
}

@keyframes fulfilling-bouncing-circle-spinner-circle-animation {
    0% {
        -webkit-transform: scale(1);
                transform: scale(1);
        border-color: transparent;
        border-top-color: inherit;
    }
    16.7% {
        border-color: transparent;
        border-top-color: initial;
        border-right-color: initial;
    }
    33.4% {
        border-color: transparent;
        border-top-color: inherit;
        border-right-color: inherit;
        border-bottom-color: inherit;
    }
    50% {
        border-color: inherit;
        -webkit-transform: scale(1);
                transform: scale(1);
    }
    62.5% {
        border-color: inherit;
        -webkit-transform: scale(1.4);
                transform: scale(1.4);
    }
    75% {
        border-color: inherit;
        -webkit-transform: scale(1);
                transform: scale(1);
        opacity: 1;
    }
    87.5% {
        border-color: inherit;
        -webkit-transform: scale(1.4);
                transform: scale(1.4);
    }
    100% {
        border-color: transparent;
        border-top-color: inherit;
        -webkit-transform: scale(1);
                transform: scale(1);
    }
}
</style>